import ky from "ky";
import { CmwClient } from "cmw-client";

/**
 * Browser-side ky instance. Calls hit `/cmw-api/*` on the frontend origin, which
 * Next.js rewrites to the backend (see next.config.ts), so no CORS is needed.
 */
export const browserKy = ky.create({ prefixUrl: "/cmw-api", timeout: 30_000 });

/** Browser-side CMW API client. */
export const browserCmw = new CmwClient(browserKy);
